(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[557],{

/***/ 1391:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "g": function() { return /* binding */ Auth; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./context/AuthContext.tsx
var AuthContext = __webpack_require__(175);
// EXTERNAL MODULE: ./components/Auth/ToggleAuth/ToggleAuth.module.scss
var ToggleAuth_module = __webpack_require__(6434);
var ToggleAuth_module_default = /*#__PURE__*/__webpack_require__.n(ToggleAuth_module);
;// CONCATENATED MODULE: ./components/Auth/ToggleAuth/ToggleAuth.tsx




const ToggleAuthOption = ()=>{
    const { authOption , setAuthOption  } = (0,AuthContext/* useAuth */.aC)();
    const getButtonStyles = (buttonName)=>{
        return "base-1 white ".concat((ToggleAuth_module_default()).toggleButton, " ").concat(authOption === buttonName && (ToggleAuth_module_default()).active);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (ToggleAuth_module_default()).toggleAuthContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                onClick: ()=>setAuthOption(AuthContext/* AuthOption.Login */.FB.Login),
                className: getButtonStyles(AuthContext/* AuthOption.Login */.FB.Login),
                children: "Sign In"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                onClick: ()=>setAuthOption(AuthContext/* AuthOption.SignUp */.FB.SignUp),
                className: getButtonStyles(AuthContext/* AuthOption.SignUp */.FB.SignUp),
                children: "Create account"
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./components/buttons/ButtonSecondary/ButtonSecondary.tsx
var ButtonSecondary = __webpack_require__(749);
;// CONCATENATED MODULE: ./components/icons/microsoft.tsx

const MicrosoftIcon = ()=>/*#__PURE__*/ _jsxs("svg", {
        width: "32px",
        height: "32px",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("rect", {
                x: "17",
                y: "17",
                width: "10",
                height: "10",
                fill: "#FEBA08"
            }),
            /*#__PURE__*/ _jsx("rect", {
                x: "5",
                y: "17",
                width: "10",
                height: "10",
                fill: "#05A6F0"
            }),
            /*#__PURE__*/ _jsx("rect", {
                x: "17",
                y: "5",
                width: "10",
                height: "10",
                fill: "#80BC06"
            }),
            /*#__PURE__*/ _jsx("rect", {
                x: "5",
                y: "5",
                width: "10",
                height: "10",
                fill: "#F25325"
            })
        ]
    });
const MinecraftIcon = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "32px",
        height: "32px",
        viewBox: "0 0 32 32",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "32",
                height: "32",
                fill: "#3A8A3A"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "8",
                y: "10",
                width: "6",
                height: "6",
                fill: "#0F1F0F"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "18",
                y: "10",
                width: "6",
                height: "6",
                fill: "#0F1F0F"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "12",
                y: "18",
                width: "8",
                height: "8",
                fill: "#0F1F0F"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "10",
                y: "20",
                width: "4",
                height: "6",
                fill: "#0F1F0F"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "18",
                y: "20",
                width: "4",
                height: "6",
                fill: "#0F1F0F"
            })
        ]
    });

;// CONCATENATED MODULE: ./components/Auth/SocialSignUp/SignUpWithMicrosoft.tsx





const SignUpWithMicrosoft = ()=>{
    const [loading, setLoading] = (0,react.useState)(false);
    const { loginWithMicrosoft  } = (0,AuthContext/* useAuth */.aC)();
    const handleMicrosoftLogin = async ()=>{
        setLoading(true);
        loginWithMicrosoft().then(async ()=>{
            // Note: Microsoft login redirects to external URL,
            // so this code won't execute. Redirect handled by callback page.
            setLoading(false);
        }).catch(()=>{
            setLoading(false);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonSecondary/* default */.Z, {
        variant: "white",
        size: "lg",
        className: "w-full my-4",
        loading: loading,
        text: "Continue with Minecraft",
        onClick: handleMicrosoftLogin,
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(MinecraftIcon, {})
    });
};

;// CONCATENATED MODULE: ./components/icons/google.tsx

const GoogleIcon = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "25",
        height: "24",
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M23.06 12.25C23.06 11.47 22.99 10.72 22.86 10H12.5V14.26H18.42C18.16 15.63 17.38 16.79 16.21 17.57V20.34H19.78C21.86 18.42 23.06 15.6 23.06 12.25Z",
                fill: "#0084FF"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.4999 23C15.4699 23 17.9599 22.02 19.7799 20.34L16.2099 17.57C15.2299 18.23 13.9799 18.63 12.4999 18.63C9.63993 18.63 7.20993 16.7 6.33993 14.1H2.67993V16.94C4.48993 20.53 8.19993 23 12.4999 23Z",
                fill: "#34A853"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.34 14.09C6.12 13.43 5.99 12.73 5.99 12C5.99 11.27 6.12 10.57 6.34 9.91001V7.07001H2.68C1.93 8.55001 1.5 10.22 1.5 12C1.5 13.78 1.93 15.45 2.68 16.93L5.53 14.71L6.34 14.09Z",
                fill: "#FBBC05"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.4999 5.38C14.1199 5.38 15.5599 5.94 16.7099 7.02L19.8599 3.87C17.9499 2.09 15.4699 1 12.4999 1C8.19993 1 4.48993 3.47 2.67993 7.07L6.33993 9.91C7.20993 7.31 9.63993 5.38 12.4999 5.38Z",
                fill: "#EA4335"
            })
        ]
    });

;// CONCATENATED MODULE: ./components/icons/email.tsx

const EmailIcon = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M12.6667 0.666687H3.33333C2.4496 0.667746 1.60237 1.01928 0.97748 1.64417C0.352588 2.26906 0.00105857 3.11629 0 4.00002L0 12C0.00105857 12.8838 0.352588 13.731 0.97748 14.3559C1.60237 14.9808 2.4496 15.3323 3.33333 15.3334H12.6667C13.5504 15.3323 14.3976 14.9808 15.0225 14.3559C15.6474 13.731 15.9989 12.8838 16 12V4.00002C15.9989 3.11629 15.6474 2.26906 15.0225 1.64417C14.3976 1.01928 13.5504 0.667746 12.6667 0.666687ZM3.33333 2.00002H12.6667C13.0659 2.00081 13.4557 2.12103 13.786 2.34522C14.1163 2.56942 14.3719 2.88732 14.52 3.25802L9.41467 8.36402C9.03895 8.73823 8.53028 8.94833 8 8.94833C7.46972 8.94833 6.96105 8.73823 6.58533 8.36402L1.48 3.25802C1.6281 2.88732 1.88374 2.56942 2.21403 2.34522C2.54432 2.12103 2.93414 2.00081 3.33333 2.00002ZM12.6667 14H3.33333C2.8029 14 2.29419 13.7893 1.91912 13.4142C1.54405 13.0392 1.33333 12.5305 1.33333 12V5.00002L5.64267 9.30669C6.26842 9.93086 7.11617 10.2814 8 10.2814C8.88383 10.2814 9.73158 9.93086 10.3573 9.30669L14.6667 5.00002V12C14.6667 12.5305 14.456 13.0392 14.0809 13.4142C13.7058 13.7893 13.1971 14 12.6667 14Z",
            fill: "#8B90B3"
        })
    });

// EXTERNAL MODULE: ./components/Inputs/validators.ts
var validators = __webpack_require__(9200);
// EXTERNAL MODULE: ./utils/strings.ts
var strings = __webpack_require__(4574);
// EXTERNAL MODULE: ./components/Inputs/Input.module.scss
var Input_module = __webpack_require__(5534);
var Input_module_default = /*#__PURE__*/__webpack_require__.n(Input_module);
;// CONCATENATED MODULE: ./components/Inputs/InputEmail/InputEmail.tsx






const InputEmail = (props)=>{
    const handleEmailChange = (event)=>{
        event.persist();
        const value = event.target.value;
        if ((0,validators/* validEmail */.u$)(value) && props.setEmail) {
            props.setEmail({
                value: value,
                validators: (0,validators/* getInputValidators */.Ex)(value, props.isRequired, props.minLength, props.maxLength, true)
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Input_module_default()).defaultIconContainer,
                style: props.styles,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (Input_module_default()).iconLeft,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmailIcon, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        id: props.id,
                        type: "email",
                        placeholder: "Username or email",
                        autoComplete: "username",
                        value: props.email.value,
                        disabled: props.disabled,
                        onChange: (event)=>handleEmailChange(event)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                className: (Input_module_default()).error,
                children: (0,strings/* buildStringFromArray */.Gj)(props.email.validators)
            })
        ]
    });
};
/* harmony default export */ var InputEmail_InputEmail = (InputEmail);

;// CONCATENATED MODULE: ./components/icons/lock.tsx

const LookIcon = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_36_6368)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M12.6668 5.616V4.66667C12.6668 3.42899 12.1752 2.242 11.3 1.36684C10.4248 0.491665 9.23784 0 8.00016 0C6.76249 0 5.5755 0.491665 4.70033 1.36684C3.82516 2.242 3.3335 3.42899 3.3335 4.66667V5.616C2.73974 5.87514 2.23436 6.30168 1.87916 6.84347C1.52397 7.38527 1.33435 8.01882 1.3335 8.66667V12.6667C1.33455 13.5504 1.68608 14.3976 2.31098 15.0225C2.93587 15.6474 3.7831 15.9989 4.66683 16H11.3335C12.2172 15.9989 13.0645 15.6474 13.6893 15.0225C14.3142 14.3976 14.6658 13.5504 14.6668 12.6667V8.66667C14.666 8.01882 14.4764 7.38527 14.1212 6.84347C13.766 6.30168 13.2606 5.87514 12.6668 5.616ZM4.66683 4.66667C4.66683 3.78261 5.01802 2.93477 5.64314 2.30964C6.26826 1.68452 7.11611 1.33333 8.00016 1.33333C8.88422 1.33333 9.73206 1.68452 10.3572 2.30964C10.9823 2.93477 11.3335 3.78261 11.3335 4.66667V5.33333H4.66683V4.66667ZM13.3335 12.6667C13.3335 13.1971 13.1228 13.7058 12.7477 14.0809C12.3726 14.456 11.8639 14.6667 11.3335 14.6667H4.66683C4.1364 14.6667 3.62769 14.456 3.25262 14.0809C2.87754 13.7058 2.66683 13.1971 2.66683 12.6667V8.66667C2.66683 8.13623 2.87754 7.62753 3.25262 7.25245C3.62769 6.87738 4.1364 6.66667 4.66683 6.66667H11.3335C11.8639 6.66667 12.3726 6.87738 12.7477 7.25245C13.1228 7.62753 13.3335 8.13623 13.3335 8.66667V12.6667Z",
                        fill: "#8B90B3"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M8.00016 9.33331C7.82335 9.33331 7.65378 9.40355 7.52876 9.52858C7.40373 9.6536 7.3335 9.82317 7.3335 9.99998V11.3333C7.3335 11.5101 7.40373 11.6797 7.52876 11.8047C7.65378 11.9297 7.82335 12 8.00016 12C8.17697 12 8.34654 11.9297 8.47157 11.8047C8.59659 11.6797 8.66683 11.5101 8.66683 11.3333V9.99998C8.66683 9.82317 8.59659 9.6536 8.47157 9.52858C8.34654 9.40355 8.17697 9.33331 8.00016 9.33331Z",
                        fill: "#8B90B3"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_36_6368",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: "white"
                    })
                })
            })
        ]
    });

;// CONCATENATED MODULE: ./components/Inputs/InputPassword/InputPassword.tsx






const InputPassword = (props)=>{
    const [showPassword, setShowPassword] = (0,react.useState)(false);
    const handlePasswordChange = (event)=>{
        event.persist();
        const value = event.target.value;
        props.setPassword({
            value: event.target.value,
            validators: [
                (0,validators/* required */.C1)(value),
                (0,validators/* minLength */.Ei)(value, 8),
                (0,validators/* maxLength */.BS)(value, 128),
                props.comparePassword ? (0,validators/* matchPassword */.mw)(props.comparePassword, value) : true
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Input_module_default()).defaultIconContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (Input_module_default()).iconLeft,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LookIcon, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        id: props.id,
                        type: showPassword ? "text" : "password",
                        placeholder: "Password",
                        autoComplete: "current-password",
                        value: props.password.value,
                        disabled: props.disabled,
                        onChange: (event)=>handlePasswordChange(event)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (Input_module_default()).iconRight,
                        children: showPassword ? /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                            className: (Input_module_default()).active,
                            onClick: ()=>setShowPassword(false),
                            width: "20",
                            height: "20",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            style: {
                                cursor: "pointer"
                            },
                            role: "button",
                            "aria-label": "Hide password",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z",
                                fill: "currentColor"
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                            onClick: ()=>setShowPassword(true),
                            width: "20",
                            height: "20",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            style: {
                                cursor: "pointer"
                            },
                            role: "button",
                            "aria-label": "Show password",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z",
                                fill: "currentColor"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                className: (Input_module_default()).error,
                children: (0,strings/* buildStringFromArray */.Gj)(props.password.validators)
            })
        ]
    });
};
/* harmony default export */ var InputPassword_InputPassword = (InputPassword);

// EXTERNAL MODULE: ./components/Auth/Separator/Separator.module.scss
var Separator_module = __webpack_require__(7489);
var Separator_module_default = /*#__PURE__*/__webpack_require__.n(Separator_module);
;// CONCATENATED MODULE: ./components/Auth/Separator/Separator.tsx



const Separator = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Separator_module_default()).separator,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Separator_module_default()).separatorLine
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "caption-1 white ".concat((Separator_module_default()).separatorText),
                children: "OR"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Separator_module_default()).separatorLine
            })
        ]
    });
};

// EXTERNAL MODULE: ./utils/arrays.ts
var arrays = __webpack_require__(91);
// EXTERNAL MODULE: ./components/Inputs/InputText/InputText.tsx
var InputText = __webpack_require__(2469);
// EXTERNAL MODULE: ./components/Auth/LoginForm/LoginForm.module.scss
var LoginForm_module = __webpack_require__(965);
var LoginForm_module_default = /*#__PURE__*/__webpack_require__.n(LoginForm_module);
// EXTERNAL MODULE: ./node_modules/@carbon/icons-react/es/generated/bucket-6.js
var bucket_6 = __webpack_require__(6160);
;// CONCATENATED MODULE: ./components/Auth/LoginForm/LoginForm.tsx














const LoginForm = ()=>{
    const router = (0,next_router.useRouter)();
    const { setAuthOption , loginWithEmailAndPassword , loginWithGoogle  } = (0,AuthContext/* useAuth */.aC)();
    const [loading, setLoading] = (0,react.useState)(false);
    const [googleLoading, setGoogleLoading] = (0,react.useState)(false);
    const [showEmailLogin, setShowEmailLogin] = (0,react.useState)(false);
    const [email, setEmail] = (0,react.useState)(InputText/* initialText */.WG);
    const [password, setPassword] = (0,react.useState)(InputText/* initialText */.WG);
    const [formValid, setFormValid] = (0,react.useState)(false);
    const pathname = router.pathname;
    (0,react.useEffect)(()=>{
        setFormValid(email.value && (0,arrays/* isAllTrue */.IE)(email.validators) && password.value && (0,arrays/* isAllTrue */.IE)(password.validators) || false);
    }, [
        email,
        password
    ]);
    const handleFormSubmit = (event)=>{
        event.preventDefault();
        setLoading(true);
        const data = {
            email: email.value,
            password: password.value
        };
        console.log("[LoginForm] Starting email login...");
        loginWithEmailAndPassword(data).then(async ()=>{
            const authPages = [
                "/",
                "/login",
                "/signup"
            ];
            const url = authPages.includes(pathname) ? "/generator" : pathname;
            await router.push(url);
            setLoading(false);
        }).catch((error)=>{
            setLoading(false);
        });
    };
    const handleGoogleLogin = async ()=>{
        setGoogleLoading(true);
        loginWithGoogle().then(()=>{
            const authPages = [
                "/",
                "/login",
                "/signup"
            ];
            const url = authPages.includes(pathname) ? "/generator" : pathname;
            // Use hard redirect to avoid flash
            window.location.href = url;
        }).catch(()=>{
            setGoogleLoading(false);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (LoginForm_module_default()).loginContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SignUpWithMicrosoft, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (LoginForm_module_default()).minecraftInfo,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: (LoginForm_module_default()).infoText,
                    children: "Sign in with your Minecraft account to enable direct skin uploads!"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Separator, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                children: !showEmailLogin ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col gap-3 mb-6",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonSecondary/* default */.Z, {
                            variant: "white",
                            size: "lg",
                            className: "w-full",
                            loading: googleLoading,
                            disabled: googleLoading,
                            onClick: handleGoogleLogin,
                            text: "Continue with Google",
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(GoogleIcon, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonSecondary/* default */.Z, {
                            variant: "white",
                            size: "lg",
                            className: "w-full",
                            onClick: ()=>setShowEmailLogin(true),
                            text: "Login with email",
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(bucket_6/* Email */.GT, {
                                size: 24
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (LoginForm_module_default()).emailLoginForm,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col gap-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(InputEmail_InputEmail, {
                                    id: "inputEmailLogin",
                                    label: "Email",
                                    email: email,
                                    setEmail: setEmail
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(InputPassword_InputPassword, {
                                    id: "inputPasswordLogin",
                                    password: password,
                                    setPassword: setPassword,
                                    disabled: false
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "app-link body-3 white main ".concat((LoginForm_module_default()).linkForget),
                            onClick: ()=>setAuthOption(AuthContext/* AuthOption.Reset */.FB.Reset),
                            children: "Forgot password?"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonSecondary/* default */.Z, {
                            size: "lg",
                            className: "w-full mt-8",
                            disabled: !formValid,
                            loading: loading,
                            text: "Sign in",
                            onClick: handleFormSubmit
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mt-4",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonSecondary/* default */.Z, {
                                variant: "white",
                                size: "lg",
                                className: "w-full",
                                loading: googleLoading,
                                disabled: googleLoading,
                                onClick: handleGoogleLogin,
                                text: "Continue with Google",
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(GoogleIcon, {})
                            })
                        })
                    ]
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./context/ToastContext.tsx
var ToastContext = __webpack_require__(5887);
// EXTERNAL MODULE: ./components/icons/user.tsx
var user = __webpack_require__(7235);
// EXTERNAL MODULE: ./components/Auth/RegisterForm/RegisterForm.module.scss
var RegisterForm_module = __webpack_require__(9493);
var RegisterForm_module_default = /*#__PURE__*/__webpack_require__.n(RegisterForm_module);
;// CONCATENATED MODULE: ./components/Auth/RegisterForm/RegisterForm.tsx















const RegisterForm = ()=>{
    const router = (0,next_router.useRouter)();
    const { registerWithEmailAndPassword , loginWithGoogle  } = (0,AuthContext/* useAuth */.aC)();
    const { showSuccessAlert  } = (0,ToastContext/* useToastContext */.a)();
    const [loading, setLoading] = (0,react.useState)(false);
    const [googleLoading, setGoogleLoading] = (0,react.useState)(false);
    const [name, setName] = (0,react.useState)(InputText/* initialText */.WG);
    const [email, setEmail] = (0,react.useState)(InputText/* initialText */.WG);
    const [password, setPassword] = (0,react.useState)(InputText/* initialText */.WG);
    const [formValid, setFormValid] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        setFormValid(name.value && (0,arrays/* isAllTrue */.IE)(name.validators) && email.value && (0,arrays/* isAllTrue */.IE)(email.validators) && password.value && (0,arrays/* isAllTrue */.IE)(password.validators) || false);
    }, [
        name,
        email,
        password
    ]);
    const handleFormSubmit = async (event)=>{
        event.preventDefault();
        const user = {
            name: name.value,
            email: email.value,
            password: password.value
        };
        setLoading(true);
        registerWithEmailAndPassword(user).then(async ()=>{
            setLoading(false);
            await router.push("/generator");
        }).catch(()=>{
            setLoading(false);
        });
    };
    const handleGoogleLogin = async ()=>{
        setGoogleLoading(true);
        loginWithGoogle().then(async ()=>{
            window.location.href = "/generator";
        }).catch((error)=>{
            console.error("[RegisterForm] Google signup error:", error);
            setGoogleLoading(false);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (RegisterForm_module_default()).registerContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SignUpWithMicrosoft, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Separator, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonSecondary/* default */.Z, {
                    variant: "white",
                    size: "lg",
                    className: "w-full",
                    loading: googleLoading,
                    disabled: googleLoading,
                    onClick: handleGoogleLogin,
                    text: "Continue with Google",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(GoogleIcon, {})
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col gap-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InputText/* default */.ZP, {
                                id: "inputTextUserName",
                                text: name,
                                setText: setName,
                                isRequired: true,
                                minValueLength: 2,
                                maxValueLength: 50,
                                placeholder: "Name",
                                iconLeft: /*#__PURE__*/ (0,jsx_runtime.jsx)(user/* UserIcon */.t, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InputEmail_InputEmail, {
                                id: "inputEmailRegister",
                                label: "Email",
                                email: email,
                                setEmail: setEmail
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InputPassword_InputPassword, {
                                id: "inputPasswordRegister",
                                password: password,
                                setPassword: setPassword,
                                disabled: false
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonSecondary/* default */.Z, {
                        size: "lg",
                        className: "w-full mt-8",
                        disabled: !formValid,
                        loading: loading,
                        text: "Create account",
                        onClick: handleFormSubmit
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "caption-1 white ".concat((RegisterForm_module_default()).caption),
                children: [
                    "By creating an account, you agree to our",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "",
                        className: "app-link caption-1 grey",
                        children: "Terms of Service"
                    }),
                    " ",
                    "and",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "",
                        className: "app-link caption-1 grey",
                        children: "Privacy & Cookie Statement."
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/icons/arrowBack.tsx

const ArrowBackIcon = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "24",
        height: "14",
        viewBox: "0 0 24 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M0.879999 4.91002L4.75 1.00002C4.84296 0.906294 4.95357 0.831899 5.07542 0.78113C5.19728 0.730362 5.32799 0.704224 5.46 0.704224C5.59201 0.704224 5.72272 0.730362 5.84458 0.78113C5.96643 0.831899 6.07704 0.906294 6.17 1.00002C6.35625 1.18738 6.46079 1.44084 6.46079 1.70502C6.46079 1.96921 6.35625 2.22266 6.17 2.41002L2.61 6.00002H23C23.2652 6.00002 23.5196 6.10538 23.7071 6.29292C23.8946 6.48045 24 6.73481 24 7.00002C24 7.26524 23.8946 7.51959 23.7071 7.70713C23.5196 7.89467 23.2652 8.00002 23 8.00002H2.55L6.17 11.61C6.26373 11.703 6.33812 11.8136 6.38889 11.9354C6.43966 12.0573 6.4658 12.188 6.4658 12.32C6.4658 12.452 6.43966 12.5827 6.38889 12.7046C6.33812 12.8265 6.26373 12.9371 6.17 13.03C6.07704 13.1238 5.96643 13.1981 5.84458 13.2489C5.72272 13.2997 5.59201 13.3258 5.46 13.3258C5.32799 13.3258 5.19728 13.2997 5.07542 13.2489C4.95357 13.1981 4.84296 13.1238 4.75 13.03L0.879999 9.15002C0.318197 8.58752 0.00263977 7.82503 0.00263977 7.03002C0.00263977 6.23502 0.318197 5.47252 0.879999 4.91002Z",
            fill: "white"
        })
    });

// EXTERNAL MODULE: ./components/buttons/ButtonPrimary/ButtonPrimary.tsx
var ButtonPrimary = __webpack_require__(3994);
;// CONCATENATED MODULE: ./components/Auth/ResetForm/ResetForm.tsx










const ResetForm = ()=>{
    const { setAuthOption , resetPassword  } = (0,AuthContext/* useAuth */.aC)();
    const { showSuccessAlert , showErrorAlert  } = (0,ToastContext/* useToastContext */.a)();
    const [email, setEmail] = (0,react.useState)(InputText/* initialText */.WG);
    const [formValid, setFormValid] = (0,react.useState)(false);
    const [loading, setLoading] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        setFormValid(email.value && (0,arrays/* isAllTrue */.IE)(email.validators) || false);
    }, [
        email
    ]);
    const handleFormSubmit = (event)=>{
        event.preventDefault();
        setLoading(true);
        resetPassword(email.value).then(async ()=>{
            showSuccessAlert("A recover link has been sent to the email ".concat(email.value));
            setAuthOption(AuthContext/* AuthOption.Login */.FB.Login);
            setLoading(false);
        }).catch(()=>{
            showErrorAlert("An error occurred while resetting your password, please try again later.");
            setLoading(false);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (LoginForm_module_default()).loginContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (LoginForm_module_default()).titleContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        onClick: ()=>setAuthOption(AuthContext/* AuthOption.Login */.FB.Login),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowBackIcon, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "headline-5 white ".concat((LoginForm_module_default()).resetTitle),
                        children: "Reset your Password"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InputEmail_InputEmail, {
                        id: "inputEmailReset",
                        email: email,
                        setEmail: setEmail
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonPrimary/* default */.Z, {
                        disabled: !formValid,
                        loading: loading,
                        text: "Reset password",
                        onClick: handleFormSubmit
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/Auth/Auth.module.scss
var Auth_module = __webpack_require__(6520);
var Auth_module_default = /*#__PURE__*/__webpack_require__.n(Auth_module);
;// CONCATENATED MODULE: ./components/Auth/Auth.tsx








const Auth = ()=>{
    const { authOption  } = (0,AuthContext/* useAuth */.aC)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Auth_module_default()).authContainer,
        children: [
            authOption !== AuthContext/* AuthOption.Reset */.FB.Reset && /*#__PURE__*/ (0,jsx_runtime.jsx)(ToggleAuthOption, {}),
            authOption === AuthContext/* AuthOption.Login */.FB.Login && /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginForm, {}),
            authOption === AuthContext/* AuthOption.SignUp */.FB.SignUp && /*#__PURE__*/ (0,jsx_runtime.jsx)(RegisterForm, {}),
            authOption === AuthContext/* AuthOption.Reset */.FB.Reset && /*#__PURE__*/ (0,jsx_runtime.jsx)(ResetForm, {})
        ]
    });
};


/***/ }),

/***/ 789:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _GeneratingOverlay_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6395);
/* harmony import */ var _GeneratingOverlay_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_GeneratingOverlay_module_scss__WEBPACK_IMPORTED_MODULE_2__);



const loadingMessages = [
    "Crafting your unique skin...",
    "Mining for the perfect pixels...",
    "Placing blocks with care...",
    "Adding the finishing touches...",
    "Almost ready to play!",
    "Painting your character...",
    "Polishing the details...",
    "Making it shine..."
];
const GeneratingOverlay = (param)=>{
    let { isVisible , estimatedSeconds =30 , message , displayTime =true  } = param;
    const [currentMessageIndex, setCurrentMessageIndex] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    const [elapsed, setElapsed] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!isVisible) {
            setElapsed(0);
            setCurrentMessageIndex(0);
            return;
        }
        // Update elapsed time every second
        const timer = setInterval(()=>{
            setElapsed((prev)=>prev + 1);
        }, 1000);
        // Rotate messages every 4 seconds
        const messageTimer = setInterval(()=>{
            setCurrentMessageIndex((prev)=>(prev + 1) % loadingMessages.length);
        }, 4000);
        return ()=>{
            clearInterval(timer);
            clearInterval(messageTimer);
        };
    }, [
        isVisible
    ]);
    if (!isVisible) return null;
    // Cap progress at 95% until complete to avoid misleading users
    const progress = Math.min(elapsed / estimatedSeconds * 100, 95);
    const remaining = Math.max(Math.ceil(estimatedSeconds - elapsed), 0);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_GeneratingOverlay_module_scss__WEBPACK_IMPORTED_MODULE_2___default().overlay),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_GeneratingOverlay_module_scss__WEBPACK_IMPORTED_MODULE_2___default().content),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_GeneratingOverlay_module_scss__WEBPACK_IMPORTED_MODULE_2___default().blockContainer),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_GeneratingOverlay_module_scss__WEBPACK_IMPORTED_MODULE_2___default().block),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_GeneratingOverlay_module_scss__WEBPACK_IMPORTED_MODULE_2___default().blockFace) + " " + (_GeneratingOverlay_module_scss__WEBPACK_IMPORTED_MODULE_2___default().front)
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_GeneratingOverlay_module_scss__WEBPACK_IMPORTED_MODULE_2___default().blockFace) + " " + (_GeneratingOverlay_module_scss__WEBPACK_IMPORTED_MODULE_2___default().back)
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_GeneratingOverlay_module_scss__WEBPACK_IMPORTED_MODULE_2___default().blockFace) + " " + (_GeneratingOverlay_module_scss__WEBPACK_IMPORTED_MODULE_2___default().right)
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_GeneratingOverlay_module_scss__WEBPACK_IMPORTED_MODULE_2___default().blockFace) + " " + (_GeneratingOverlay_module_scss__WEBPACK_IMPORTED_MODULE_2___default().left)
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_GeneratingOverlay_module_scss__WEBPACK_IMPORTED_MODULE_2___default().blockFace) + " " + (_GeneratingOverlay_module_scss__WEBPACK_IMPORTED_MODULE_2___default().top)
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_GeneratingOverlay_module_scss__WEBPACK_IMPORTED_MODULE_2___default().blockFace) + " " + (_GeneratingOverlay_module_scss__WEBPACK_IMPORTED_MODULE_2___default().bottom)
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: (_GeneratingOverlay_module_scss__WEBPACK_IMPORTED_MODULE_2___default().message),
                    children: message !== null && message !== void 0 ? message : loadingMessages[currentMessageIndex]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_GeneratingOverlay_module_scss__WEBPACK_IMPORTED_MODULE_2___default().progressContainer),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_GeneratingOverlay_module_scss__WEBPACK_IMPORTED_MODULE_2___default().progressBar),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_GeneratingOverlay_module_scss__WEBPACK_IMPORTED_MODULE_2___default().progressFill),
                                style: {
                                    width: "".concat(progress, "%")
                                }
                            })
                        }),
                        displayTime && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: (_GeneratingOverlay_module_scss__WEBPACK_IMPORTED_MODULE_2___default().timeEstimate),
                            children: remaining > 0 ? "".concat(remaining, " seconds remaining") : "Just a moment more..."
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (GeneratingOverlay);


/***/ }),

/***/ 5815:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _components_GeneratingOverlay_GeneratingOverlay__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(789);


const FullScreenLoader = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_GeneratingOverlay_GeneratingOverlay__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        isVisible: props.isLoading,
        estimatedSeconds: 3,
        message: "Loading dashboard ...",
        displayTime: false
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FullScreenLoader);


/***/ }),

/***/ 9416:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _Loader_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3856);
/* harmony import */ var _Loader_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_Loader_module_scss__WEBPACK_IMPORTED_MODULE_1__);


const Loader = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "".concat((_Loader_module_scss__WEBPACK_IMPORTED_MODULE_1___default().loaderContainer), " ").concat(props.primary && (_Loader_module_scss__WEBPACK_IMPORTED_MODULE_1___default().primary)),
        style: props.styles,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                className: (_Loader_module_scss__WEBPACK_IMPORTED_MODULE_1___default().loader),
                width: props.width || 50,
                height: props.height || 50,
                color: props.color || "#8FCA5C",
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 200 200",
                fill: "none",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("defs", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("linearGradient", {
                                id: "spinner-secondHalf",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                        offset: "30%",
                                        stopOpacity: "0",
                                        stopColor: "currentColor"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                        offset: "100%",
                                        stopOpacity: "0.5",
                                        stopColor: "currentColor"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("linearGradient", {
                                id: "spinner-firstHalf",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                        offset: "0%",
                                        stopOpacity: "1",
                                        stopColor: "currentColor"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                        offset: "100%",
                                        stopOpacity: "0.5",
                                        stopColor: "currentColor"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                        strokeWidth: "10",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                stroke: "url(#spinner-secondHalf)",
                                d: "M 4 100 A 96 96 0 0 1 196 100"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                stroke: "url(#spinner-firstHalf)",
                                d: "M 196 100 A 96 96 0 0 1 4 100"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                stroke: "currentColor",
                                strokeLinecap: "round",
                                d: "M 4 100 A 96 96 0 0 1 4 98"
                            })
                        ]
                    })
                ]
            }),
            props.message && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "base-1 ".concat(props.fontColor, " ").concat((_Loader_module_scss__WEBPACK_IMPORTED_MODULE_1___default().loaderText)),
                children: props.message
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Loader);


/***/ }),

/***/ 2737:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _Brand_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4103);
/* harmony import */ var _Brand_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Brand_module_scss__WEBPACK_IMPORTED_MODULE_2__);



const Brand = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
        onClick: props.onClick,
        className: "brand ".concat((_Brand_module_scss__WEBPACK_IMPORTED_MODULE_2___default())[props.variant || "default"]),
        style: props.styles,
        children: "Minecraft Skin Generator"
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Brand);


/***/ }),

/***/ 3994:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _ButtonPushable_ButtonPushable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7272);



const ButtonPrimary = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ButtonPushable_ButtonPushable__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        loading: props.loading,
        disabled: props.disabled,
        onClick: props.onClick,
        className: props.className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
            className: "flex items-center gap-2 font-poppins font-semibold text-sm",
            children: [
                props.icon && props.icon,
                props.text
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ButtonPrimary);


/***/ }),

/***/ 7272:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _components_Loaders_LoaderCircle_Loader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9416);
/* harmony import */ var _utils_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4697);



const ButtonPushable = (param)=>{
    let { size ="md" , children , onClick , disabled , loading , type ="button" , className  } = param;
    const isDisabled = disabled || loading;
    const isLarge = size === "lg";
    const frontClasses = isLarge ? "px-8 py-12 text-white -translate-y-6 group-hover:-translate-y-2 group-active:-translate-y-0.5" : "px-6 py-3 text-[#242C36] -translate-y-[0.4rem] group-hover:-translate-y-[0.5rem] group-active:-translate-y-[2px]";
    const transitionClasses = isLarge ? [
        "transition-transform duration-[900ms] [transition-timing-function:cubic-bezier(0.25,0.8,0.25,1)]",
        "group-hover:duration-[450ms] group-hover:[transition-timing-function:cubic-bezier(0.25,0.8,0.25,1)]",
        "group-active:duration-[34ms]"
    ] : [
        "transition-transform duration-[600ms] [transition-timing-function:cubic-bezier(0.3,0.7,0.4,1)]",
        "group-hover:duration-[250ms] group-hover:[transition-timing-function:cubic-bezier(0.3,0.7,0.4,1.5)]",
        "group-active:duration-[34ms]"
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,_utils_styles__WEBPACK_IMPORTED_MODULE_2__.cn)("relative text-center", isDisabled && "opacity-50 pointer-events-none", className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
            type: type,
            className: "group relative w-full p-0 rounded-xl border-none bg-[#477A1E] cursor-pointer outline-offset-1 transition-[filter] duration-[250ms]",
            onClick: onClick,
            disabled: isDisabled,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "absolute top-0 left-0 w-full h-full rounded-xl bg-[#477A1E]"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    className: (0,_utils_styles__WEBPACK_IMPORTED_MODULE_2__.cn)("relative flex justify-center items-center gap-4 self-stretch", "bg-[#70B237] rounded-xl will-change-transform", ...transitionClasses, frontClasses),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: (0,_utils_styles__WEBPACK_IMPORTED_MODULE_2__.cn)("flex justify-center items-center gap-4", loading && "invisible"),
                            children: children
                        }),
                        loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Loaders_LoaderCircle_Loader__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                            isLoading: true,
                            width: 18,
                            height: 18,
                            color: "white",
                            styles: {
                                position: "absolute"
                            }
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ButtonPushable);


/***/ }),

/***/ 749:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _components_Loaders_LoaderCircle_Loader__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9416);
/* harmony import */ var _utils_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4697);




const sizeClasses = {
    sm: "h-8 px-3 text-xs gap-1.5",
    md: "h-10 px-4 text-sm gap-2",
    lg: "h-12 px-6 text-base gap-2.5",
    xl: "h-16 px-10 text-xl gap-3"
};
const variantClasses = {
    default: "bg-[#8FCA5C] text-[#242C36] border-2 border-[#8FCA5C] hover:border-white",
    white: "bg-white text-[#242C36] border-2 border-[#e0e0e0] hover:border-[#c0c0c0]"
};
const iconSizes = {
    sm: 14,
    md: 16,
    lg: 18,
    xl: 22
};
const ButtonSecondary = (param)=>{
    let { size ="md" , variant ="default" , loading =false , disabled , text , onClick , type ="button" , className , style , icon , iconPosition ="left"  } = param;
    const isDisabled = disabled || loading;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        style: style,
        className: (0,_utils_styles__WEBPACK_IMPORTED_MODULE_3__.cn)("inline-flex items-center justify-center rounded-lg font-poppins font-medium transition-all duration-150 cursor-pointer", "disabled:opacity-50 disabled:cursor-not-allowed", variantClasses[variant], sizeClasses[size], className),
        children: loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Loaders_LoaderCircle_Loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            isLoading: true,
            width: iconSizes[size],
            height: iconSizes[size],
            color: variant === "white" ? "#242C36" : "white"
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                icon && iconPosition === "left" && icon,
                text,
                icon && iconPosition === "right" && icon
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ButtonSecondary);


/***/ }),

/***/ 7235:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ UserIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

const UserIcon = (props)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 20 29",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                cx: "10",
                cy: "5.375",
                r: "3.5",
                stroke: props.color || "#8B90B3",
                strokeWidth: "3"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M6.92814 14.875C8.27529 12.5417 11.6432 12.5417 12.9903 14.875L17.8081 23.2197L9.95923 26.9631L2.11034 23.2197L6.92814 14.875Z",
                stroke: props.color || "#8B90B3",
                strokeWidth: "3"
            })
        ]
    });


/***/ }),

/***/ 6520:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"authContainer":"Auth_authContainer__fkWX_"};

/***/ }),

/***/ 965:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"loginContainer":"LoginForm_loginContainer__Vgi_d","linkForget":"LoginForm_linkForget__XeHCz","minecraftInfo":"LoginForm_minecraftInfo__NLZHw","infoText":"LoginForm_infoText__VnxjT","emailLoginForm":"LoginForm_emailLoginForm__ROjNs","slideDown":"LoginForm_slideDown__qsCnP"};

/***/ }),

/***/ 9493:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"registerContainer":"RegisterForm_registerContainer__Bjgwl","caption":"RegisterForm_caption__o_ZiK"};

/***/ }),

/***/ 7489:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"separator":"Separator_separator__X_pwU","separatorLine":"Separator_separatorLine__Z4pzV","separatorText":"Separator_separatorText__B_AtQ"};

/***/ }),

/***/ 6434:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"toggleAuthContainer":"ToggleAuth_toggleAuthContainer__0Kdca","toggleButton":"ToggleAuth_toggleButton__mXzTH","active":"ToggleAuth_active__H4FDW"};

/***/ }),

/***/ 6395:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"overlay":"GeneratingOverlay_overlay__8ZIDQ","fadeIn":"GeneratingOverlay_fadeIn__vfV20","content":"GeneratingOverlay_content__pL2d3","blockContainer":"GeneratingOverlay_blockContainer__VsH2t","block":"GeneratingOverlay_block__y_BD6","rotate":"GeneratingOverlay_rotate__XsEZe","blockFace":"GeneratingOverlay_blockFace__xyZDg","front":"GeneratingOverlay_front__b6rbS","back":"GeneratingOverlay_back__q5nBV","right":"GeneratingOverlay_right__Bbi18","left":"GeneratingOverlay_left__5oeh3","top":"GeneratingOverlay_top__oPbie","bottom":"GeneratingOverlay_bottom__SbdTH","message":"GeneratingOverlay_message__BsrTv","pulse":"GeneratingOverlay_pulse__B99cf","progressContainer":"GeneratingOverlay_progressContainer__ObIu9","progressBar":"GeneratingOverlay_progressBar__vd_K2","progressFill":"GeneratingOverlay_progressFill__d3RLU","timeEstimate":"GeneratingOverlay_timeEstimate__bj_0e","tip":"GeneratingOverlay_tip__21n1Q"};

/***/ }),

/***/ 3856:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"loaderContainer":"Loader_loaderContainer__E52sw","primary":"Loader_primary__enB1K","loader":"Loader_loader__PhD0y","rotate":"Loader_rotate__niAw_","loaderText":"Loader_loaderText__g7nNR"};

/***/ }),

/***/ 4103:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"default":"Brand_default__jriME","white":"Brand_white__MXPYV Brand_default__jriME","large":"Brand_large__c9hmX Brand_default__jriME"};

/***/ })

}]);